import { render, staticRenderFns } from "./GeneroCard.vue?vue&type=template&id=4bb9611b&scoped=true&"
import script from "./GeneroCard.vue?vue&type=script&lang=js&"
export * from "./GeneroCard.vue?vue&type=script&lang=js&"
import style0 from "./GeneroCard.vue?vue&type=style&index=0&id=4bb9611b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9611b",
  null
  
)

export default component.exports